import { useCallback, useState } from 'react'
import { searchDropDownOptions } from '@labrav/common'

import type { MarketplaceMultipleApnSearchOption } from './MarketplaceMultipleApn.types'

export const useMarketplaceMultipleApnSearch = () => {
  const [searchNow, setSearchNow] = useState(false)
  const [showCrossMark, setShowCrossMark] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [selectedOption, setSelectedOption] =
    useState<MarketplaceMultipleApnSearchOption>(
      searchDropDownOptions.multipleApnOptions[0]
    )

  const handleSearchClick = useCallback(async () => {}, [])

  return {
    searchNow,
    setSearchNow,
    showCrossMark,
    setShowCrossMark,
    inputValue,
    setInputValue,
    selectedOption,
    setSelectedOption,
    handleSearchClick,
  }
}
